const AdminMetricStrip = ({ items = [] }) => {
  if (!items.length) {
    return null;
  }

  return (
    <section className="admin-metric-strip">
      {items.map((item) => {
        const classes = [
          'admin-metric-card',
          item.onClick ? 'admin-metric-card-button' : '',
          item.active ? 'admin-metric-card-active' : '',
        ]
          .filter(Boolean)
          .join(' ');

        const content = (
          <>
            <div className="admin-metric-label">{item.label}</div>
            <div className="admin-metric-value">{item.value}</div>
            {item.helper ? <div className="admin-metric-helper">{item.helper}</div> : null}
          </>
        );

        if (item.onClick) {
          return (
            <button
              key={item.key || item.label}
              type="button"
              className={classes}
              onClick={item.onClick}
              aria-pressed={item.active ? 'true' : 'false'}
            >
              {content}
            </button>
          );
        }

        return (
          <div className={classes} key={item.key || item.label}>
            {content}
          </div>
        );
      })}
    </section>
  );
};

export default AdminMetricStrip;
